import PropTypes from 'prop-types';
import {
  SubTitle,
  Title,
  LeadGenCoverContent,
  Illo,
  LeadGenWrapper
} from './styles';

const LeadGenCover = ({ scrollRef, children, heroContent, form }) => {
  const { title, subTitle, image } = heroContent;
  const isSuccessful = form === 'SUCCESSFUL';
  return (
    <LeadGenWrapper $form={isSuccessful}>
      {isSuccessful ? null : (
        <LeadGenCoverContent>
          <Illo src={image.default} width="112px" height="78px" alt="illo" />
          <Title ref={scrollRef}>{title}</Title>
          <SubTitle>{subTitle}</SubTitle>
        </LeadGenCoverContent>
      )}
      {children}
    </LeadGenWrapper>
  );
};

LeadGenCover.propTypes = {
  scrollRef: PropTypes.objectOf(PropTypes.any).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  heroContent: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.string.isRequired
};

export default LeadGenCover;
